package gr.tech.GRAttestation.components.inputs

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.css.disabled
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.attestation.SalesData
import gr.tech.GRAttestation.models.skus.SkuPreviewDTO
import gr.tech.GRAttestation.sections.forms.ProductRowContainer
import gr.tech.GRAttestation.styles.grstyles.DarkGreenHoverButtonStyle
import gr.tech.GRAttestation.styles.store.PortalInputLabelStyle
import gr.tech.GRAttestation.styles.store.PortalInputStyle
import gr.tech.GRAttestation.styles.store.PortalSelectStyle
import gr.tech.GRAttestation.util.Constants
import gr.tech.GRAttestation.util.formatCurrency
import gr.tech.util.validateInput
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun StoreProductsInput(
    skuOptions: List<SkuPreviewDTO>,
    salesData: MutableList<SalesData>,
    onRowUpdate: (Int, SalesData) -> Unit,
    onAddProduct: () -> Unit,
    onRemoveProduct: (Int) -> Unit,
) {
    val disableButton by remember(salesData.size) { mutableStateOf(salesData.size >= Constants.FORM.SALES_DATA_LIMIT) }

    salesData.forEachIndexed { index, sale ->
        key(sale.id) {
            var mutableCopy by remember { mutableStateOf(sale) }

            Div(attrs = ProductRowContainer.toModifier().toAttrs()) {
                SelectInput(
                    direction = FlexDirection.Column,
                    inputId = "AttestationSkuModelInput",
                    labelText = "Product",
                    value = "",
                    options = skuOptions.mapIndexed { index, it -> index.toString() to "${it.sku} - ${it.description} (${formatCurrency(it.unitPrice)})" },
                    containerModifier = Modifier.width(80.percent),
                    labelModifier = PortalInputLabelStyle.toModifier().fontSize(9.px),
                    selectModifier = PortalSelectStyle.toModifier(),
                    onInputChange = {
                        val selectedIndex =
                            it.value?.toIntOrNull() ?: 0 //Either valid option or defaults to the first one.
                        mutableCopy = mutableCopy.copy(
                            skuModel = skuOptions[selectedIndex]
                        )
                        onRowUpdate(index, mutableCopy)
                    }
                )

                IntegerInput(
                    direction = FlexDirection.Column,
                    inputId = "AttestationSaleQuantity",
                    labelText = "QTY",
                    value = mutableCopy.quantity,
                    min = 1,
                    showError = false,
                    containerModifier = Modifier.width(15.percent),
                    labelModifier = PortalInputLabelStyle.toModifier().fontSize(9.px),
                    inputModifier = PortalInputStyle.toModifier(),
                    onValueChange = { parsed ->
                        val validNumber = parsed.validateInput(min = 1)
                        if (validNumber.isBlank()) {
                            mutableCopy = mutableCopy.copy(quantity = parsed!!)
                        }
                        onRowUpdate(index, mutableCopy)
                    }
                )

                Button(
                    attrs = Modifier.classNames("btn", "mt-2").width(5.percent)
                        .thenIf(
                            condition = index == 0,
                            other = Modifier.visibility(Visibility.Hidden)
                        )
                        .toAttrs {
                            disabled(index == 0)
                            onClick {
                                onRemoveProduct(index)
                            }
                        }
                ) {
                    FaX(Modifier.color(Colors.DarkRed))
                }
            }
        }
    }

    Button(
        attrs = Modifier.classNames("btn")
            .margin(bottom = 1.5.cssRem)
            .width(Width.FitContent).fontSize(12.px).whiteSpace(WhiteSpace.NoWrap)
            .then(DarkGreenHoverButtonStyle.toModifier())
            .thenIf(
                condition = disableButton,
                other = Modifier.classNames("disabled")
            )
            .onClick {
                it.preventDefault()
                onAddProduct()
            }
            .disabled(disableButton)
            .toAttrs()
    ) {
        FaPlus(
            modifier = Modifier.color(Colors.White).classNames("me-1"),
            size = IconSize.SM
        )
        Text("Add Product")
    }
}